module.exports = __webpack_public_path__ + "img/Ardunic Elements-08.12044e40.svg";